import { connect } from 'react-redux';
import FeedsComponent from '../components/FeedsComponent';
import { getNewsCategoryIfNeeded } from '../../news/actions/NewsActions';

const mapStateToProps = (state) => ({
    newsCategories: state.news.newsCategories,
});
const mapDispatchToProps = (dispatch) => ({
    getNewsCategoryIfNeeded: () => {
        dispatch(getNewsCategoryIfNeeded());
    },
});
const FeedsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(FeedsComponent);

export default FeedsContainer;
